import { Box, Button, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import SendIcon from '@mui/icons-material/Send';

import { useDispatch, useSelector } from "react-redux";
import { warhouseProductsAction, warhouseUpdateAction } from "../asyncActions/warhouseActions";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { setWarehouseDocumentData } from "../store/gridDataSlice";
import SubmitButton from "../UI/SubmitButton";
import { setModal } from "../store/modalSlice";

const style = {
    "*": {
        fontWeight: '600'
    },
    "& .edited": {
        backgroundColor: '#f1f1f1',
        color: '#1a3e72',
    },
    // "& .local_edit": {
    //     backgroundColor: '#aeff7e',
    //     color: '#1a3e72',
    // }
}

function WarehousePage() {

    const { t } = useTranslation()

    const apiRef = useGridApiRef()

    const dispatch = useDispatch()

    const [error, setError] = useState(null)

    const {
        products,
        dataLoad
    } = useSelector((store) => store.warhouse)

    const {
        warehouseDocumentData
    } = useSelector((store) => store.gridData)

    const {
        postLoad
    } = useSelector((store) => store.postLoad)

    const rows = products.map(el => {
        const findLocal = warehouseDocumentData.find(row => el.id === row.id)
        return (findLocal) ? { ...el, current_qnt: findLocal.current_qnt } : el
    })


    const columns = [

        { field: 'id', headerName: 'ID', width: 40 },
        {
            field: 'name',
            flex: 1,
            headerName: t('grid.product_name'),
            minWidth: 250,
            editable: false,
        },
        {
            field: 'unit_type',
            flex: 1,
            headerName: t('grid.product_name'),
            minWidth: 130,
            editable: false,
        },
        {
            field: 'avg_price',
            flex: 1,
            headerName: t('grid.avg_price'),
            type: 'number',
            minWidth: 130,
            editable: false,
        },
        {
            field: 'quantity',
            flex: 1,
            headerName: t('grid.qnt'),
            type: 'number',
            minWidth: 130,
            editable: false,
            cellClassName: (params) => {
                return clsx('', {
                    edited: params.row.edited,
                    local_edit: params.row.localEdited,
                })
            },
        },
        {
            field: 'current_qnt',
            headerName: t('grid.current_qnt'),
            type: 'number',
            flex: 1,
            minWidth: 130,
            editable: true,
        },
    ]

    const handleCellClick = useCallback((params) => {
        try {
            apiRef.current.startCellEditMode({
                id: params.id,
                field: params.field,
            })
        } catch (e) {
        }
    },
        [apiRef],
    );


    useEffect(() => {
        dispatch(warhouseProductsAction())
    }, [dispatch])

    const onCeildEdit = (params) => {
        setTimeout(() => {
            let gridProducts = new Array(...apiRef.current.getRowModels()).map(el => el[1])
            dispatch(setWarehouseDocumentData(gridProducts))
        })
    }

    const handleSubmit = () => {
        setError(null)
        const data = warehouseDocumentData.filter(el => typeof el.current_qnt === 'number')
        if (data.length){
            const modalPayload = {
                active: true,
                content: 'warehouseDocument',
                data: {
                    path: '/',
                    payload: data
                }
            }
            dispatch(setModal(modalPayload))
        } else {
            setError("At least 1 product quantity must be filled in")
        }
    }

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '25px',
            width: '100%',
            height: '100%'
        }}>
            <Typography variant="h4" align="center">{t('page_text.warhouse_inventory')}</Typography>
            {error && <Typography sx={{ color: 'red',  }} align="center">{error}</Typography>}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                justifyContent: 'center'
            }}>
            </Box>
            <Box
                sx={{ ...style, height: '100%' }}
            >
                <DataGrid
                    loading={dataLoad || postLoad}
                    hideFooterPagination={dataLoad}
                    handleCellClick={handleCellClick}
                    apiRef={apiRef}
                    columns={columns}
                    onCellEditStop={onCeildEdit}
                    rows={rows}
                    showCellVerticalBorder
                />
            </Box>
            <Box sx={{
                display: 'flex',
                padding: '15px 0px',
                justifyContent: 'end'
            }}>
                <SubmitButton endIcon={<SendIcon/>}  onClick={handleSubmit}>
                    {t('button.approve')}
                </SubmitButton>
            </Box>
        </Box>
    )
}

export default WarehousePage
